/**
 * @generated SignedSource<<aca08a06e6337db6fdcf4ad3b70058aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTurnpikeCreateScreenMutation$variables = {
  email: string;
  password: string;
};
export type IntegrationTurnpikeCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationTurnpike: {
      readonly __typename: "ActivateTurnpikeFailure";
      readonly message: string;
    } | {
      readonly __typename: "ActivateTurnpikeSuccess";
      readonly integrationTurnpike: {
        readonly id: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type IntegrationTurnpikeCreateScreenMutation = {
  response: IntegrationTurnpikeCreateScreenMutation$data;
  variables: IntegrationTurnpikeCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  },
  {
    "kind": "Variable",
    "name": "password",
    "variableName": "password"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationTurnpike",
  "kind": "LinkedField",
  "name": "integrationTurnpike",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTurnpikeCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activateIntegrationTurnpike",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "type": "ActivateTurnpikeSuccess",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "type": "ActivateTurnpikeFailure",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationTurnpikeCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activateIntegrationTurnpike",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "ActivateTurnpikeSuccess",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "ActivateTurnpikeFailure",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "feda87f04fd640de03f955cc70981318",
    "id": null,
    "metadata": {},
    "name": "IntegrationTurnpikeCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTurnpikeCreateScreenMutation(\n  $email: String!\n  $password: String!\n) {\n  store {\n    activateIntegrationTurnpike(password: $password, email: $email) {\n      __typename\n      ... on ActivateTurnpikeSuccess {\n        integrationTurnpike {\n          id\n        }\n        __typename\n      }\n      ... on ActivateTurnpikeFailure {\n        message\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0bbfdc6300515a33576e9cfe21402fa";

export default node;
